import { AppNavComponent  } from './app-nav/app-nav.component';

export const SharedComponents = [
  AppNavComponent
]

export {
  AppNavComponent
}

